<template>
    <section class="section-hero section-shaped my-0">
        <div class="shape shape-style-1 shape-primary">

        </div>
        <div class="container shape-container d-flex align-items-center">
            <div class="col px-0">
                <div class="row justify-content-center align-items-center">
                    <div class="col-lg-6 text-left pt-lg">
                        <h1 class="text-white">DANIEL LOPA</h1>
                        <p class="lead text-white mt-4 mb-5">Retoucheur photo</p>
                        <p class="text-white">
                         Passionné par la photo, je me suis lancé depuis maintenant 4 ans dans l'apprentissage de la retouche photo.
                        Je suis maintenant spécialisé dans la retouche beauté et j'entreprends des missions pour des photographes indépendants et des agences.
                        </p>
                        <div class="btn-wrapper">
                            <base-button tag="a"
                                         href="https://www.instagram.com/lopadaniel/"
                                         target="_blank"
                                         class="mb-3 mb-sm-0 text-white"
                                         type="dark"
                                         icon="fa fa-instagram">

                            </base-button>
                            <base-button tag="a"
                                        target="_blank"
                                         href="https://www.linkedin.com/in/daniel-lopa-6b3a867a/"
                                         class="mb-3 mb-sm-0 text-white"
                                         type="dark"
                                         icon="fa fa-linkedin">

                            </base-button>
                            <base-button tag="a"
                                        target="_blank"
                                         href="mailto:daniel@lopa.io"
                                         class="mb-3 mb-sm-0 text-white"
                                         type="dark"
                                         icon="ni ni-email-83">
                                daniel@lopa.io
                            </base-button>
                        </div>
                    </div>
                     <div class="col-lg-4 col-sm-1 col-xs-1 col-md-1 mb-lg-auto mt-lg-2">
                    <div class="rounded shadow-lg overflow-hidden transform-perspective-right">
                        <b-carousel id="carousel1"
                                    controls
                                    indicators>
                            <!-- Text slides with image -->
                            <b-carousel-slide img-src="img/portfolio/magasine.jpg"></b-carousel-slide>
                            <b-carousel-slide img-src="img/portfolio/Maayan5.jpg"></b-carousel-slide>
                            <b-carousel-slide img-src="img/portfolio/kareen4.jpg"></b-carousel-slide>
                        </b-carousel>
                    </div>

                </div>

                </div>
                                <div class="row justify-content-center align-items-center">

                        <base-button tag="a" href="#portfolio" class="mt-5 mb-5 text-white" outline  type="secondary" icon="fa fa-arrow-down">  </base-button>
                        </div>
            </div>
        </div>
    </section>
</template>
<script>
import { BCarousel } from "bootstrap-vue/esm/components/carousel/carousel";
import { BCarouselSlide } from "bootstrap-vue/esm/components/carousel/carousel-slide";

export default {
  components: {
    BCarousel,
    BCarouselSlide
  }
};</script>
<style>
</style>
